import * as React from 'react';
import { mappingHasProperty } from '../helper';
import { convertToLinkObject } from './profile-teaser/helper';

export function useProfileTeaserFields(hit, mapping) {
  return React.useMemo(() => {
    const getValue = (key, defaultValue = '') => mappingHasProperty(mapping, hit, key) ? hit[mapping[key]] : defaultValue;
    let links = [];
    getValue('links', []).forEach(entry => {
      const link = convertToLinkObject(entry);
      if (link) { links.push(link); }
    });

    const splitLines = (input) => (
      typeof input === 'string' ? input.split('\n').map(s => s.trim()).filter(Boolean) : []
    );
    const extraFields = [];
    const fieldNames = splitLines(mapping && mapping.extra_fields);
    const labels = splitLines(mapping && mapping.extra_field_labels);
    fieldNames.forEach((fieldName, index) => {
      const raw = hit[fieldName];
      let value;
      if (Array.isArray(raw)) {
        value = raw.filter(Boolean).join(', ');
      } else if (raw === undefined || raw === null || typeof raw === 'object') {
        value = '';
      } else {
        value = String(raw);
      }
      if (value === '') { return; }
      extraFields.push({
        key: fieldName,
        label: labels[index] || fieldName,
        value,
      });
    });

    return {
      title: getValue('title'),
      jobRole: getValue('job_role'),
      location: getValue('location'),
      image: getValue('profile_image_url'),
      specialization: getValue('specialization'),
      institutionName: getValue('institution_name'),
      extraFields,
      pageUrl: getValue('profile_page_url'),
      links,
    };
  }, [hit, mapping]);
}
